import Navbar from "../components/layout/Navbar";
import Footer from "../components/layout/Footer";

function AboutPage() {
  return (
    <div className="min-h-screen bg-white text-black">
      <Navbar />
      <main>
        <section className="page-hero">
          <div className="container">
            {/* <div className="badges">
              <span className="badge">About</span>
              <span className="badge">Mission-Focused</span>
              <span className="badge">Secure Delivery</span>
            </div> */}
            <span className="eyebrow">
              About | Mission-Focused | Secure Delivery
            </span>
            <h1>About ThoughtCodes</h1>
            <p>
              ThoughtCodes is a technology solutions firm delivering secure,
              scalable, and mission-focused digital services for government and
              mission-driven organizations.
            </p>
          </div>
        </section>
        <section className="section">
          <div className="container split">
            <div>
              <div className="section-head">
                <div className="tag">Company Overview</div>
                <h2>
                  Built to support digital modernization in high-accountability
                  environments
                </h2>
              </div>
              <div className="flex flex-col gap-2">
                <p>
                  ThoughtCodes specializes in delivering modern, high-performing
                  digital solutions that enable organizations to transition from
                  legacy systems to scalable, cloud-enabled platforms.
                </p>
                <p>
                  We combine technical excellence with a practical,
                  mission-first mindset to ensure solutions are not only
                  innovative but also reliable, secure, and sustainable. Our
                  team works closely with stakeholders to understand mission
                  objectives, define clear requirements, and deliver measurable
                  outcomes.
                </p>
                <p>
                  From system architecture and application development to
                  testing and deployment, we provide full lifecycle support that
                  drives efficiency, improves user experience, and enhances
                  operational performance.
                </p>
                <p>
                  We bring small-business agility with enterprise-level
                  discipline allowing us to respond quickly while maintaining
                  structure, quality, and compliance across every engagement.
                </p>
              </div>
            </div>
            <div className="card">
              <h3>What makes us different</h3>
              <ul className="list-check">
                <li>Mission-focused, outcome-driven delivery</li>
                <li>Flexible and responsive teaming partner</li>
                <li>
                  Integrated expertise across software, cloud, cybersecurity,
                  and AI
                </li>
                <li>
                  Proven experience supporting federal and regulated
                  environments
                </li>
                <li>
                  Agile and DevSecOps-driven approach to accelerate delivery
                </li>
                <li>
                  Security-first mindset aligned with compliance standards
                </li>
                <li>
                  Scalable solutions designed for long-term sustainability
                </li>
              </ul>
            </div>
          </div>
        </section>

        <section className="section soft gradient-bg">
          <div className="container">
            <div className="section-head center">
              <h2>Company data</h2>
            </div>
            <div className="grid-2">
              <div className="page-card stat stat-interactive !shadow-[0_12px_32px_rgba(2,6,23,0.12)]">
                <h3>Certifications</h3>
                <div className="text-black">
                  Small Business
                  <br />
                  SBA Certified Small Disadvantaged Business
                  <br />
                  SWaM Certified
                  <br />
                  ISO Certified
                </div>
              </div>
              <div className="page-card stat stat-interactive !shadow-[0_12px_32px_rgba(2,6,23,0.12)]">
                <h3>Corporate snapshot</h3>
                <div className="text-black">
                  <strong>CAGE:</strong> 8F4J8
                  <br />
                  <strong>UEI:</strong> TKAGKBGE2LQ3 <br />
                  <strong>NAICS:</strong> 541512, 541511, 541519, 518210,
                  541330, 541611
                  <br />
                  <strong>GSA MAS Contract:</strong> 47QTCA24D00C1
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="section soft ">
          <div className="container split">
            <div>
              <div className="section-head">
                <h2>Guided by principles that drive mission success</h2>
                <p>
                  At ThoughtCodes, our work is grounded in a set of core values
                  that shape how we deliver solutions, collaborate with clients,
                  and achieve mission outcomes. These principles guide every
                  engagement and ensure consistency, quality, and long-term
                  impact.
                </p>
              </div>
              <div>
                <div className="table-like">
                  <div className="row-item stat stat-interactive">
                    <strong>Integrity</strong>
                    <div>
                      We operate with transparency, honesty, and accountability
                      in every interaction—ensuring trust, consistency, and
                      alignment across our work, decisions, and outcomes.
                    </div>
                  </div>
                  <div className="row-item stat stat-interactive">
                    <strong>Responsiveness</strong>
                    <div>
                      We actively listen, understand mission needs, and respond
                      with urgency and precision to deliver timely and effective
                      solutions.
                    </div>
                  </div>
                  <div className="row-item stat stat-interactive">
                    <strong>Innovation</strong>
                    <div>
                      We apply modern technologies and forward-thinking
                      approaches to solve complex challenges and continuously
                      improve how missions are supported.
                    </div>
                  </div>
                  <div className="row-item stat stat-interactive">
                    <strong>Value-Driven Delivery</strong>
                    <div>
                      We focus on delivering high-impact solutions through
                      efficient, scalable approaches that maximize value while
                      maintaining quality and performance.
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="card">
              <h3>What You Can Expect from ThoughtCodes</h3>
              <ul className="list-check">
                <li>
                  Trusted partner committed to transparency and accountability
                </li>
                <li>Responsive, mission-aligned delivery teams</li>
                <li>Innovative solutions leveraging modern technologies</li>
                <li>
                  Efficient and scalable delivery focused on long-term value
                </li>
              </ul>
            </div>
          </div>
        </section>

        <section className="section gradient-bg">
          <div className="container">
            <div className="section-head center">
              <h2>How ThoughtCodes Delivers Consistent Mission Success</h2>
              <p>
                We combine technical expertise, disciplined delivery, and a
                mission-first mindset to deliver secure, scalable, and
                high-impact solutions across every engagement.
              </p>
            </div>
            <div className="grid-4">
              <div className="page-card stat stat-interactive !shadow-[0_12px_32px_rgba(2,6,23,0.12)]">
                <h3>Stronger Delivery Teams</h3>
                <p>
                  Cross functional teams with expertise in software engineering,
                  cloud, cybersecurity, and quality engineering, ensuring
                  end-to-end delivery excellence.
                </p>
              </div>
              <div className="page-card stat stat-interactive !shadow-[0_12px_32px_rgba(2,6,23,0.12)]">
                <h3>Trusted Client Partnerships</h3>
                <p>
                  Long term relationships with federal and mission-driven
                  clients built on reliability, performance, and consistent
                  delivery outcomes.
                </p>
              </div>
              <div className="page-card stat stat-interactive !shadow-[0_12px_32px_rgba(2,6,23,0.12)]">
                <h3>Modernization Driven Approach</h3>
                <p>
                  Focused on transitioning legacy systems to secure,
                  cloud-ready, and scalable architectures aligned with federal
                  modernization priorities.
                </p>
              </div>
              <div className="page-card stat stat-interactive !shadow-[0_12px_32px_rgba(2,6,23,0.12)]">
                <h3>Continuous Innovation</h3>
                <p>
                  Ongoing investment in AI-enabled automation, DevSecOps, and
                  emerging technologies to improve speed, quality, and mission
                  impact.
                </p>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}

export default AboutPage;
